import { Facets } from "../data/db/types";
import { Maybe } from "../utils/types";
import { useSWR } from "./useSWR";

/**
 * TODO - Use actual "search facets"
 */
export default function useFacets(fallbackData?: Maybe<Facets>) {
  const apiUri = "/api/facets";
  const { data } = useSWR<{ facets: Facets }>(apiUri, {
    fallbackData: { facets: fallbackData }
  });
  return data && "facets" in data ? data.facets : undefined;
}
